export const balancedCompute = 1/5;
export const balancedBlock = 10;
export const heavyCompute = 3/5;
export const heavyBlock = 20;
export const lightCompute = 0;
export const lightBlock = 2;
